.spinner {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--text-muted);
}

.circle {
  width: 1rem;
  height: 1rem;
  border: 2px solid var(--border);
  border-top-color: var(--border-strong);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

/* Whoever asked the system not to animate gets a static ring, not a jitter. */
@media (prefers-reduced-motion: reduce) {
  .circle {
    animation: none;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
